export interface CandidateScreeningObj {
  id?: number;
}
export interface CandidatePayload {
  id?: number;
  candidateId: number;
  amountOfRenters?: number;
  amountOfSigners?: number;
  amountOfGuarantors?: number;
  viewing?: boolean;
  videoViewing?: boolean;
  introduction?: string;
  rentingDate?: string;
  rentingDateExplanation?: string;
  rentalPeriod?: string;
  sharedIncome?: number;
  bidPrice?: number;
  bidPriceExplanation?: string;
  pets?: boolean;
  amountOfAdults?: number;
  amountOfKids?: number;
  petsDetails?: string;
  employmentType?: string;
  review: number;
}

export const CandidatePayloadProxy = new Proxy<CandidatePayload>(
  {} as CandidatePayload,
  {
    get(target, prop: keyof CandidatePayload, receiver): string {
      return prop as string; // Cast prop to string to ensure type correctness
    },
  }
);

export interface CandidateScreeningPayload {
  id: number;
  income: number;
  candidateId: number;
  employmentType?: string;
  screeningType?: string;
  firstname?: string;
  initials?: string;
  surname?: string;
  birthplace?: string;
  street?: string;
  houseNumber?: string;
  postalCode?: string;
  city?: string;
  country?: string;
  phoneNumber?: string;
  email?: string;
  province?: string;
  birthdate?: string;
}
